import type {ActionsObservable} from 'redux-observable';
import {Observable} from 'rxjs';
import {switchMap, map, catchError} from 'rxjs/operators';

import {fetchList} from 'nutshell-core/entities/fetch-list';
import * as Schema from 'nutshell-core/schema';
import {safelyParseError} from 'nutshell-core/utils';
import _ from 'underscore';

import {
    updateMcfxCompaniesListData,
    failMcfxCompaniesListData,
    // @ts-expect-error
    McfxCompaniesListRequestedAction,
    updateMcfxCompaniesSchema,
    failMcfxCompaniesSchema,
} from './companies-actions';

export const requestMcfxCompaniesListEpic = (action$: ActionsObservable<any>) =>
    action$.ofType('MCFXCOMPANIES_LIST_DATA_REQUESTED').pipe(
        switchMap((action: McfxCompaniesListRequestedAction) => {
            const {filters, pageNum = 1, columns, sort, q} = action.payload;

            // Our pagination components aren't 0-based, but this specific
            // request expects page 0 to be the first page. Using Math.max() here
            // in case older URLs with page 0 are still in the wild
            const adjustedPageNum = Math.max(0, pageNum - 1);

            const listRequestStream = Observable.from(
                fetchList('mcfxcompanies', {
                    filter: filters,
                    sort,
                    q,
                    page: {page: adjustedPageNum},
                    fields: columns,
                })
            );

            const companiesListDataStream = listRequestStream.pipe(
                map((response) => updateMcfxCompaniesListData(response))
            );

            return companiesListDataStream.pipe(
                catchError((err) => {
                    const safeError = safelyParseError(err);

                    return Observable.of(failMcfxCompaniesListData(safeError));
                })
            );
        })
    );

export const requestMcfxCompaniesSchemaEpic = (action$: ActionsObservable<any>) =>
    action$.ofType('MCFXCOMPANIES_SCHEMA_REQUESTED').pipe(
        switchMap(() => {
            const schemaRequestStream = Observable.from(
                Schema.fetchSchema('mcfxcompanies/list/fields')
            );

            const companiesSchemaDataStream = schemaRequestStream.pipe(
                map((response) => {
                    const schemaProps = _.mapObject(response.properties, (val, key) => {
                        return {...val, name: key};
                    });

                    return updateMcfxCompaniesSchema(schemaProps);
                })
            );

            return companiesSchemaDataStream.pipe(
                catchError((err) => {
                    const safeError = safelyParseError(err);

                    return Observable.of(failMcfxCompaniesSchema(safeError));
                })
            );
        })
    );
